export enum RegisteredBusinessStatus {
  ERROR = "ERROR",
  INCOMPLETE = "INCOMPLETE",
  REGISTERED = "REGISTERED",
  CALCULATING = "CALCULATING",
}

export const RegisteredBusinessStatusColourMap = {
  [RegisteredBusinessStatus.ERROR]: "inputError",
  [RegisteredBusinessStatus.CALCULATING]: "grayDisabled",
  [RegisteredBusinessStatus.INCOMPLETE]: "warning",
  [RegisteredBusinessStatus.REGISTERED]: "primary",
} as const satisfies Record<RegisteredBusinessStatus, string>;

export const RegisteredBusinessStatusTitleMap = {
  [RegisteredBusinessStatus.ERROR]: "Error",
  [RegisteredBusinessStatus.CALCULATING]: "Working",
  [RegisteredBusinessStatus.INCOMPLETE]: "Incomplete",
  [RegisteredBusinessStatus.REGISTERED]: "Registered",
} as const satisfies Record<RegisteredBusinessStatus, string>;
